var path = 'app/scripts/modules/core/src/pipeline/config/stages/core/stageConfigField/stageConfigField.directive.html';
var html = "<div class=\"form-group\">\n  <label class=\"col-md-3 sm-label-right\">\n    <span class=\"label-text\" ng-bind=\"vm.label\"></span>\n    <help-field key=\"{{vm.helpKey}}\"></help-field>\n  </label>\n  <div class=\"col-md-{{vm.fieldColumns}}\">\n    <ng-transclude></ng-transclude>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/core/stageConfigField/stageConfigField.directive.html
// module id = 995
// module chunks = 0